import {Button, Modal} from '@logistics-frontend/blocks'
import React from 'react'

import {AdvertInfoContent} from '../content'
import {AdvertModalProps as Props} from '../types'
import * as classes from './AdvertInfoDesktop.classes'

function AdvertModalDesktop({onClose, content}: Props): React.ReactElement<Props> {
  return (
    <Modal className={classes.root} onClose={onClose} opened>
      <Modal.Body p={undefined}>
        <AdvertInfoContent contentItems={content} />
      </Modal.Body>
      <Modal.Footer>
        <Button onPress={onClose}>Закрыть</Button>
      </Modal.Footer>
    </Modal>
  )
}

export default AdvertModalDesktop
